import React, { type FunctionComponent } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import { Flex } from 'legacy/dash-blocks/flex/Flex'
import { type OrdersListApiApproxGMV } from 'legacy/sections/orders/components/list/utils/ordersList.types'
import { type OrderStatus } from 'legacy/sections/orders/utils/orders.types'

interface Props {
  loading: boolean
  approxGmv?: OrdersListApiApproxGMV
  orderStatus: OrderStatus
}

export const OrdersListTabItemDetails: FunctionComponent<Props> = ({
  loading,
  approxGmv,
  orderStatus,
}) => (
  <Flex align="center" overrideStyle={{ minHeight: 20 }}>
    {!loading && approxGmv && (
      <FormattedMessage
        id="orders.nav.approx_gmv"
        values={{
          amount: (
            <FormattedNumber
              // eslint-disable-next-line react/style-prop-object
              style="currency"
              value={approxGmv[orderStatus || 'all']}
              currency="USD"
              minimumFractionDigits={0}
              maximumFractionDigits={2}
            />
          ),
        }}
      />
    )}
  </Flex>
)
